(() => {
  const portal = document.querySelector('[data-exchange-portal]');
  if (!portal) return;

  const configEl = document.querySelector('[data-exchange-portal-config]');
  let config = { whatsappPhone: '966534729544', labels: {} };
  if (configEl) {
    try {
      config = { ...config, ...JSON.parse(configEl.textContent) };
    } catch (_) {
      /* keep defaults */
    }
  }

  const labels = config.labels || {};
  const step4Label = portal.querySelector('[data-exchange-step-4-label]');
  const step4Hint = portal.querySelector('[data-exchange-step-4-hint]');

  const updateStep4 = (type) => {
    if (!step4Label || !step4Hint) return;
    if (type === 'exchange') {
      step4Label.textContent = labels.step4Exchange || step4Label.textContent;
      step4Hint.textContent = labels.step4HintExchange || step4Hint.textContent;
    } else if (type === 'return') {
      step4Label.textContent = labels.step4Return || step4Label.textContent;
      step4Hint.textContent = labels.step4HintReturn || step4Hint.textContent;
    }
  };

  portal.querySelectorAll('input[name="request_type"]').forEach((radio) => {
    radio.addEventListener('change', () => updateStep4(radio.value));
  });

  const tabs = portal.querySelectorAll('[data-exchange-tab]');
  const panels = portal.querySelectorAll('[data-exchange-panel]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.exchangeTab;
      tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.exchangePanel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    });
  });

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const showError = (form, message) => {
    const errorEl = form.querySelector('[data-exchange-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = !message;
  };

  const openWhatsApp = (text) => {
    const url = `https://wa.me/${config.whatsappPhone}?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const fillTemplate = (template, data) =>
    template.replace(/\{\{(\w+)\}\}/g, (_, key) => (data[key] != null ? String(data[key]) : ''));

  portal.querySelector('[data-exchange-form="request"]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    showError(form, '');

    const order = form.order_number.value.trim();
    const email = form.email.value.trim();
    const phone = form.phone.value.trim();
    const typeInput = form.querySelector('input[name="request_type"]:checked');
    const item = form.item.value.trim();
    const notes = form.notes.value.trim();
    const conditions = form.conditions.checked;

    if (!order || !email || !typeInput || !conditions) {
      showError(form, labels.errorRequired || 'Please complete all required fields.');
      return;
    }
    if (!isValidEmail(email)) {
      showError(form, labels.errorEmail || 'Please enter a valid email address.');
      return;
    }

    const typeLabel =
      typeInput.value === 'exchange' ? labels.typeExchange || 'Exchange' : labels.typeReturn || 'Return';

    const message = fillTemplate(labels.messageRequest || '', {
      order,
      email,
      phone: phone || '—',
      type: typeLabel,
      item: item || '—',
      notes: notes || '—'
    });

    openWhatsApp(message);
  });

  portal.querySelector('[data-exchange-form="track"]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    showError(form, '');

    const order = form.order_number.value.trim();
    const email = form.email.value.trim();

    if (!order || !email) {
      showError(form, labels.errorRequired || 'Please complete all required fields.');
      return;
    }
    if (!isValidEmail(email)) {
      showError(form, labels.errorEmail || 'Please enter a valid email address.');
      return;
    }

    const message = fillTemplate(labels.messageTrack || '', { order, email });
    openWhatsApp(message);
  });
})();

(() => {
  const portal = document.querySelector('[data-warranty-portal]');
  if (!portal) return;

  const configEl = document.querySelector('[data-warranty-portal-config]');
  let config = { whatsappPhone: '966534729544', labels: {} };
  if (configEl) {
    try {
      config = { ...config, ...JSON.parse(configEl.textContent) };
    } catch (_) {
      /* keep defaults */
    }
  }

  const labels = config.labels || {};
  const tabs = portal.querySelectorAll('[data-warranty-tab]');
  const panels = portal.querySelectorAll('[data-warranty-panel]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.warrantyTab;
      tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.warrantyPanel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    });
  });

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const showError = (form, message) => {
    const errorEl = form.querySelector('[data-warranty-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = !message;
  };

  const openWhatsApp = (text) => {
    const url = `https://wa.me/${config.whatsappPhone}?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const fillTemplate = (template, data) =>
    template.replace(/\{\{(\w+)\}\}/g, (_, key) => (data[key] != null ? String(data[key]) : ''));

  const photoInput = portal.querySelector('[data-warranty-photos]');
  const photoLabel = portal.querySelector('[data-warranty-photos-label]');

  const selectedPhotos = () =>
    Array.from((photoInput && photoInput.files) || []).filter((file) => file.type.startsWith('image/'));

  const updatePhotoLabel = () => {
    if (!photoLabel) return;
    const files = selectedPhotos();
    if (!files.length) {
      photoLabel.textContent = labels.photosEmpty || '';
      return;
    }
    photoLabel.textContent = fillTemplate(labels.photosCount || '{{count}}', { count: files.length });
  };

  photoInput?.addEventListener('change', updatePhotoLabel);

  const sharePhotosIfPossible = async (text, files) => {
    if (!files.length || !navigator.canShare || !navigator.share) return false;
    const payload = { text, files };
    if (!navigator.canShare(payload)) return false;
    try {
      await navigator.share(payload);
      return true;
    } catch (error) {
      if (error && error.name === 'AbortError') return true;
      return false;
    }
  };

  portal.querySelector('[data-warranty-form="request"]')?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    showError(form, '');

    const order = form.order_number.value.trim();
    const email = form.email.value.trim();
    const notes = form.notes ? form.notes.value.trim() : '';
    const photos = selectedPhotos();

    if (!order || !email) {
      showError(form, labels.errorRequired || 'Please complete all required fields.');
      return;
    }
    if (!isValidEmail(email)) {
      showError(form, labels.errorEmail || 'Please enter a valid email address.');
      return;
    }
    if (!photos.length) {
      showError(form, labels.errorPhotos || 'Please upload at least one photo of the piece.');
      return;
    }

    const message = fillTemplate(labels.messageRequest || '', {
      order,
      email,
      notes: notes || '—',
      photos: String(photos.length)
    });

    const shared = await sharePhotosIfPossible(message, photos);
    if (!shared) openWhatsApp(message);
  });

  portal.querySelector('[data-warranty-form="track"]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    showError(form, '');

    const order = form.order_number.value.trim();
    const email = form.email.value.trim();

    if (!order || !email) {
      showError(form, labels.errorRequired || 'Please complete all required fields.');
      return;
    }
    if (!isValidEmail(email)) {
      showError(form, labels.errorEmail || 'Please enter a valid email address.');
      return;
    }

    const message = fillTemplate(labels.messageTrack || '', { order, email });
    openWhatsApp(message);
  });
})();
